import { useNavigate, useLocation } from "react-router-dom";
import { Home, ScanLine, ShoppingCart, Truck, History, CreditCard, Users, KeyRound, Gift, Info, MessageCircle, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/lib/i18n";
import { ZapCartLogo } from "@/components/ZapCartLogo";

const MAIN = [
  ["/dashboard", "home", Home, "side-home"], ["/scanner", "scan", ScanLine, "side-scan"], ["/suppliers", "cart", ShoppingCart, "side-cart"],
  ["/cashcarry", "depot", Truck, "side-cashcarry"], ["/history", "history", History, "side-history"],
];
const MANAGER = [
  ["/settings", "sideBilling", CreditCard, "side-billing"], ["/team", "sideTeam", Users, "side-team"],
  ["/supplier-setup", "sideVault", KeyRound, "side-vault"], ["/referral", "sideReferral", Gift, "side-referral"],
];
const SUPPORT = [["/about", "sideAbout", Info, "side-about"], ["/help", "sideHelp", MessageCircle, "side-help"]];

const Item = ({ to, label, Icon, testid, active, onClick }) => (
  <button data-testid={testid} onClick={onClick}
    className={`w-full flex items-center gap-3 px-3 h-10 rounded-xl text-sm font-semibold transition-colors ${active ? "bg-blue-50 text-[#1D4ED8]" : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"}`}>
    <Icon className="w-[18px] h-[18px]" strokeWidth={active ? 2.5 : 2} />{label}
  </button>
);

export const StoreSidebar = () => {
  const { user, activeStaff, exitPin, logout } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isManager = user?.role === "owner" || user?.role === "manager";
  const row = ([to, k, Icon, testid]) => <Item key={to} to={to} label={t(k)} Icon={Icon} testid={testid} active={pathname === to || pathname.startsWith(`${to}/`)} onClick={() => navigate(to)} />;
  return (
    <aside data-testid="store-sidebar" className="hidden lg:flex fixed inset-y-0 left-0 z-40 w-64 flex-col bg-white border-r border-slate-200">
      <div className="h-16 px-5 flex items-center gap-2.5 border-b border-slate-100">
        <ZapCartLogo size={32} />
        <div className="leading-tight min-w-0">
          <p className="font-extrabold text-slate-900 font-head">Zap<span className="text-emerald-600">Basket</span></p>
          <p data-no-translate className="text-[11px] text-slate-400 truncate">{user?.store_name}</p>
        </div>
      </div>
      <nav className="flex-1 overflow-y-auto p-3 space-y-1">
        {MAIN.map(row)}
        {isManager && <><p className="px-3 pt-4 pb-1 text-[10px] font-bold uppercase tracking-wider text-slate-400">{t("sideManage")}</p>{MANAGER.map(row)}</>}
        <p className="px-3 pt-4 pb-1 text-[10px] font-bold uppercase tracking-wider text-slate-400">{t("sideSupport")}</p>
        {SUPPORT.map(row)}
      </nav>
      <div className="p-3 border-t border-slate-100 space-y-1">
        <Item label={`${t("sideSwitch")}${activeStaff ? ` (${activeStaff.name})` : ""}`} Icon={Users} testid="side-switch-staff" onClick={() => { exitPin(); navigate("/staff"); }} />
        <button data-testid="side-logout" onClick={() => { logout(); navigate("/auth"); }} className="w-full flex items-center gap-3 px-3 h-10 rounded-xl text-sm font-semibold text-red-600 hover:bg-red-50 transition-colors"><LogOut className="w-[18px] h-[18px]" /> {t("sideLogout")}</button>
      </div>
    </aside>
  );
};
